import { useGetMeQuery, useUpdateProfileMutation } from "./api"
import { ApiFormWrapper, FormError, FormInput, FormSubmitButton } from "@/form"
import { useT } from "@/i18n"

export default function Profile() {
  const { t } = useT()
  const [updateProfile] = useUpdateProfileMutation()
  const { data: me, isLoading } = useGetMeQuery()

  if (isLoading) {
    return null
  }

  return (
    <ApiFormWrapper
      defaultValues={{
        nickName: me?.nickName ?? "",
        familyName: me?.familyName ?? "",
        givenName: me?.givenName ?? "",
      }}
      action={updateProfile}
      successMessage="Successfully updated profile."
    >
      <FormInput
        name="nickName"
        label="Display name"
        required
        className="mb-3 w-full"
      />
      <div className="mb-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-4">
        <FormInput name="familyName" label="Family Name" className="w-full" />
        <FormInput name="givenName" label="Given Name" className="w-full" />
      </div>
      <FormError />
      <FormSubmitButton>{t("save")}</FormSubmitButton>
    </ApiFormWrapper>
  )
}
